import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "./CollageHero.css";

import img1 from "../../assets/images/collage1.webp";
import img2 from "../../assets/images/collage2.webp";
import img3 from "../../assets/images/collage3.webp";
import img4 from "../../assets/images/collage4.webp";

const CollageHero = () => {
  const collageRef = useRef(null);
  const [hideArrow, setHideArrow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!collageRef.current) return;
      setHideArrow(
        collageRef.current.getBoundingClientRect().bottom <= window.innerHeight
      );
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="collage-hero" ref={collageRef}>
      <div className="collage-grid">
        <img
          src={img1}
          alt="Buffet dish with sushi rolls and salad"
          loading="eager"
        />
        <img src={img2} alt="Crab legs and oysters over ice" loading="lazy" />
        <img src={img3} alt="Fried shrimp and tempura station" loading="lazy" />
        <img
          src={img4}
          alt="Assorted desserts like cream puffs and fruit"
          loading="lazy"
        />
      </div>

      <div className="collage-overlay">
        <h1>HIRO JAPANESE BUFFET</h1>
        <Link to="/buffet-pricing" className="collage-button">
          VIEW PRICING ▸
        </Link>
      </div>

      <a
        href="#carousel"
        className={`scroll-indicator ${hideArrow ? "hide" : ""}`}
        aria-label="Scroll to carousel"
      >
        <span className="scroll-text">Scroll down</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M6 9l6 6 6-6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    </section>
  );
};

export default CollageHero;
